import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { uploadPdf } from "@/features/invoice-overview/utils/uploadUtils";
import { useTenant } from "@/providers/session";
import { Upload } from "lucide-react";

export const UploadInvoiceButton = () => {
  const { t } = useTranslation();
  const { tenantId } = useTenant();
  const fileInputRef = useRef<any>(null);

  const handleUploadError = (error: any): void => {
    const errorCode = error?.data?.code;
    const errorData = error?.data?.data;

    const errMessage = errorCode
      ? (t(`server_errors.${errorCode}`, { ...errorData }) as string)
      : t("generic_error");

    toast.error(errMessage, { richColors: true });
  };

  async function handlePdfUpload(event: any): Promise<void> {
    await uploadPdf({
      files: event.target.files,
      tenantId,
      onError: handleUploadError,
    });
    event.target.value = "";
  }

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Button onClick={handleUploadClick} className="gap-2" variant="outline">
      <Upload className="h-4 w-4" />
      {t("upload")}
      <input
        type="file"
        accept=".png,.jpg,.jpeg,.pdf,.xml,.tif,.tiff"
        hidden
        multiple
        ref={fileInputRef}
        onChange={handlePdfUpload}
      />
    </Button>
  );
};
